import { utils, write } from "xlsx";

const exportJson = (xlsData, filename = 'staff_data.xlsx') => {
    // Crea un nuovo workbook
    const wb = utils.book_new();
        
    // Converti i dati in un worksheet
    const ws = utils.aoa_to_sheet(xlsData);

    // Aggiungi il worksheet al workbook
    utils.book_append_sheet(wb, ws, "Staff Data");

    // Genera il file XLSX
    const wbout = write(wb, {bookType:'xlsx', type:'array'});

    // Crea un Blob con il contenuto XLS
    const blob = new Blob([wbout], {type:"application/octet-stream"});

    // Crea un link per il download e clicca su di esso
    const link = document.createElement("a");
    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}
    
const jsonToXls = () => {
    if(document.getElementById('download-xls')){
        const filename = document.getElementById('download-xls').dataset.filename || 'staff_data.xlsx';
        document.getElementById('download-xls').addEventListener('click', function() {
            exportJson(xlsData, filename);
        });
    }
};

export default jsonToXls;